import { APPLICATION_PATHS } from '../../application-core/constants';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { NavLink } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { globalStyles as styles } from '../style/gstheme';
import withGS from '../withGShoc';

class IntegrationLink extends React.Component {

  render() {

    const { classes, data, lang } = this.props;
    const title = data && data.title ? data.title[lang] : data.id;
    const linkType = data && data.type ?
      data.type === "Ontology" ?
        "ontology"
        :
        data.type.includes("ConceptScheme") ?
          "taxonomy"
          :
          data.type.includes("Collection") || data.type.includes("OrderedCollection") ?
            "collection"
            :
            "detail"
      :
      null;
    let url;
    if (linkType) {
      // Picks up both ontologies and ontology projects
      const applicationType = data.type.includes("Ontology") ?
        APPLICATION_PATHS.ONTOLOGY_MANAGER
        :
        APPLICATION_PATHS.TAXONOMY_MANAGER;
      url = applicationType + '/project/' + linkType + '#project=' + this.props.projectIRI;
      if (linkType !== "detail") url += '&' + linkType + '=' + this.props.id;
    }

    return (
      <Tooltip title={data.id}>
        {url ?
          <NavLink to={url} className={classes.cardLink}>{title}</NavLink>
          :
          <span data-test="no-link">{title}</span>
        }
      </Tooltip>
    );
  }
}

IntegrationLink.propTypes = {
  id: PropTypes.string.isRequired,
  projectIRI: PropTypes.string.isRequired,
  classes: PropTypes.object,
  lang: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired
};

export default withStyles(styles)(withGS(IntegrationLink));